d<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="custom-scrollbar">
          <v-layout row wrap>
            <v-flex grow>
              <h3>Přehled sjednaných spoření</h3>
            </v-flex>
            <v-flex shrink>
              <v-btn color="primary" small :href="api_url_admin+'export/sporici-programy/xlsx?'+export_query" target="_blank" class="ma-0" depressed>Exportovat</v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-2" align-center>
            <v-flex xs12 sm3 lg2>
              <clientsearch label="Klient" v-model="klient" class="mx-2" :rules="[]"></clientsearch>
            </v-flex>
            <v-flex xs12 sm3 lg2>
              <osobasearch label="Spolupracovník" v-model="spolupracovnik" class="mx-2" :spolupracovnik="true"></osobasearch>
            </v-flex>
            <v-flex xs12 sm3 lg2>
              <datepicker label="Období od" class="mx-2" v-model="datum_sjednani_od" clearable></datepicker>
            </v-flex>
            <v-flex xs12 sm3 lg2>
              <datepicker label="Období do" class="mx-2" v-model="datum_sjednani_do" clearable></datepicker>
            </v-flex>
            <v-flex xs12 sm3 lg4>
              <v-btn-toggle mandatory v-model="filtr_stav" class="btn-toggle__mobile mb-3">
                <v-btn value="vse">Vše</v-btn>
                <v-btn value="aktivni">Aktivní</v-btn>
                <v-btn value="neaktivni">Neaktivní</v-btn>
              </v-btn-toggle>
            </v-flex>
          </v-layout>
          <div class="table-border__radius elevation-1">
            <v-data-table
              :headers="headers"
              :items="items"
              :pagination.sync="pagination"
              :total-items="pagination.totalItems"
              :rows-per-page-items="[25, 50, 100, 200]"
              :loading="loadingTable"
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.datum_sjednani | formatDate }}</td>
                <td>
                  <router-link :to="{ path: '/klienti/' + props.item.osoba.id }" target="_blank">
                    {{ props.item.osoba.nazev_osoby }}
                  </router-link>
                </td>
                <td>
                  <router-link :to="{ path: '/spolupracovnici/' + props.item.spolupracovnik.id }" target="_blank" v-if="props.item.spolupracovnik!=null">
                    {{ props.item.spolupracovnik.nazev_osoby }}
                  </router-link>
                </td>
                <td>{{ props.item.nazev_sporeni }}</td>
                <td>
                  <router-link :to="{ path: '/sporici-produkty/' + props.item.sporici_produkt.id }" target="_blank" v-if="props.item.sporici_produkt!=null">
                    {{ props.item.sporici_produkt.sporici_program }}
                  </router-link>
                </td>
                <td>
                  <router-link :to="{ path: '/produkty/' + props.item.cilovy_produkt.id }" target="_blank" v-if="props.item.cilovy_produkt!=null">
                    {{ props.item.cilovy_produkt.nazev }}
                  </router-link>
                </td>
                <td class="text-xs-right">{{ props.item.cilova_castka | formatMoneyInt }} {{ props.item.mena.zkratka }}</td>
                <td class="text-xs-right">{{ props.item.prvni_platba | formatMoneyInt }} {{ props.item.mena.zkratka }}</td>
                <td class="text-xs-right">{{ props.item.mesicni_platba  | formatMoneyInt }} {{ props.item.mena.zkratka }}</td>
                <td>{{ props.item.variabilni_symbol }}</td>
                <td class="text-xs-right"><span v-if="props.item.zaplaceno>0">{{props.item.zaplaceno | formatMoneyInt }} {{ props.item.mena.zkratka }}</span><span v-else>--</span></td>
                <td><span v-if="props.item.stav_sporeni=='probiha'">Probíhá</span><span v-else-if="props.item.stav_sporeni=='zruseni'">Zrušeno</span><span v-else>Dokončeno</span></td>
                <td class="text-center">
                  <router-link :to="{ path: '/klienti/' + props.item.osoba.id + '/sporici-programy/' + props.item.id }" target="_blank">
                    <v-btn color="primary" class="elevation-0" @click="dialogDetail=true">
                      <v-icon small class="mr-2">remove_red_eye</v-icon> Detail
                    </v-btn>
                  </router-link>
                </td>
              </template>
            </v-data-table>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
import RocniBonusy from '@/pages/Klienti/RocniBonusy'
import Platby from '@/pages/Klienti/Platby'
import PredaneProdukty from '@/pages/Klienti/PredaneProdukty'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      headers: [
        { text: 'Datum sjednání', value: 'datum_sjednani', width: '300px' },
        { text: 'Klient', value: 'osoba' },
        { text: 'Spolupracovník', value: 'spolupracovnik' },
        { text: 'Název spoření', value: 'nazev_sporeni' },
        { text: 'Spořící program', value: 'sporici_produkt' },
        { text: 'Cílový produkt', value: 'cilovy_produkt' },
        { text: 'Cílová částka', value: 'cilova_castka', align: 'right' },
        { text: 'První platba', value: 'prvni_platba', align: 'right' },
        { text: 'Měsíční splátka', value: 'mesicni_platba', align: 'right' },
        { text: 'VS', value: 'variabilni_symbol' },
        { text: 'Zaplaceno celkem', value: 'zaplaceno', align: 'right' },
        { text: 'Stav', value: 'stav_sporeni' },
        { text: 'Zobrazit', value: null, sortable: false, align: 'center' }
      ],
      items: [],
      item: {},
      activeTab: 0,
      tabs: [ 'platby', 'rocni_bonusy', 'graf_sporeni', 'predane_produkty' ],
      item: {},
      editMode: false,
      dialogDetail: false,
      updateItem: {},
      updating: false,
      sending: false,
      valid: true,
      dialogInit: {
        nazev_sporeni: null,
        cilova_castka: null,
        mesicni_platba: null,
        prvni_platba: null,
        datum_sjednani: null
      },
      newItem: null,
      // Dialog create end
      klient: null,
      spolupracovnik: null,
      datum_sjednani_od: null,
      datum_sjednani_do: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 50,
        sortBy: "datum_sjednani",
        totalItems: 0
      },
      filtr_stav: "vse",
      loadingTable: false,
      export_query: ""
    }
  },
  props: {
    id: String
  },
  computed: {
    api_url_admin () {
      return window.api.$api_url;
    }
  },
  watch: {
    klient () {
      this.pagination.page = 1;
      this.load();
      this.makeExportQuery();
    },
    spolupracovnik () {
      this.pagination.page = 1;
      this.load();
      this.makeExportQuery();
    },
    datum_sjednani_od () {
      this.pagination.page = 1;
      this.load();
      this.makeExportQuery();
    },
    datum_sjednani_do () {
      this.pagination.page = 1;
      this.load();
      this.makeExportQuery();
    },
    pagination: {
      handler () {
        this.load();
      },
      deep: true
    },
    filtr_stav () {
      this.pagination.page = 1;
      this.load();
      this.makeExportQuery();
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("prehledy/sjednana-sporeni/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter,
        klient: this.klient,
        spolupracovnik: this.spolupracovnik,
        datum_sjednani_od: this.datum_sjednani_od,
        datum_sjednani_do: this.datum_sjednani_do,
        stav: this.filtr_stav
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    makeExportQuery () {
      this.export_query = [
        this.klient != null ? "o=" + this.klient : null,
        this.spolupracovnik != null ? "p=" + this.spolupracovnik : null,
        this.datum_sjednani_od != null ? "ds=" + this.datum_sjednani_od : null,
        this.datum_sjednani_do != null ? "dt=" + this.datum_sjednani_do : null,
        this.filtr_stav != null && this.filtr_stav.length > 0 ? "st=" + this.filtr_stav : null
      ].filter((e) => { return e != null }).join("&");
    }
  },
  components: {
    RocniBonusy, Platby, PredaneProdukty
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Prehledy/SjednanaSporeni.vue